import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Images from "../../assests/Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { data, useLocation, useNavigate } from "react-router-dom";
import PopupModel from "../popupmodel/PopupModel";
import { type } from "@testing-library/user-event/dist/type";
import Select from "react-select";
import {
  customerData,
  executiveData,
  ordersData,
  productData,
  purchaseData,
} from "../../components/globalApi/Api";
import moment from "moment";

const NewOrder = () => {
  const { state } = useLocation();
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      invoiceNo: "",
      orderProducts: [
        {
          product: "",
          quantity: "",
          quantityType: "",
          otherQuantityType: "",
          unitPrice: "",
          discountPrice: "",
          price: "",
          orderAdd: "",
          gstPercentage: "",
          mrpPrice: "",
          hsnCode: "",
          salesDate: moment().format("YYYY-MM-DD"),
        },
      ],
      salesDate: moment().format("YYYY-MM-DD"), // today
      amtToPay: "",
      totalInvoiceAmount: state?.totalInvoiceAmount || 0,
      transactionStatus: "Pending",
      deliveryStatus: "Processing",
      selectFormat: "a5",
    },
  });
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "orderProducts",
  });

  const navigate = useNavigate();

  console.log("state", state);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productName, setProductName] = useState("");
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const selectedName = watch("customerName");
  const customersLevels = watch("customerLevel");
  const { customerName, contact } = watch();

  // GET API START
  const fetchOrderData = async (contact) => {
    return await axios.get(
      `${process.env.REACT_APP_HOST}/orders/phoneNo/${contact}`
    );
  };

  const {
    data: orderData,
    isLoading: orderLoading,
    refetch: orderRefetch,
  } = useQuery(
    ["order", contact], // contact as dependency
    () => fetchOrderData(contact), // pass contact directly
    {
      enabled: !!contact, // only run if contact exists
      refetchOnWindowFocus: false,
    }
  );
  // GET API END FOR ORDERS

  let getByNumber = (orderData && orderData?.data) || [];

  const lastOrder = getByNumber[getByNumber?.length - 1];

  const payments = (lastOrder && lastOrder?.payments) || [];
  const existingBalance =
    payments?.length > 0
      ? Number(payments[payments?.length - 1].balanceAmount || 0)
      : 0;
  // let existingBalance = lastOrder && lastOrder?.payments?.[0].balanceAmount || 0;
  // ---------------------------------------------------------

  // Calculation Start
  const [paymentList, setPaymentList] = useState(state?.payments || []);

  const currentAmt = Number(useWatch({ control, name: "amtToPay" }) || 0);
  const totalAmount = Number(
    useWatch({ control, name: "totalInvoiceAmount" }) || 0
  );
  const customerLevelBase = Number(
    useWatch({ control, name: "customerLevel" }) || 0
  );

  //  Compute cumulative received only from stored list
  const cumulativeReceived = paymentList?.reduce(
    (sum, p) => sum + Number(p.receivedAmount || 0),
    0
  );

  // Add existing balance to totalAmount only once
  const totalWithPrevious = Number(totalAmount) + Number(existingBalance);

  //  Avoid logic here that depends on currentAmt
  // const currentBalance = totalAmount - cumulativeReceived;
  const currentBalance = totalWithPrevious - cumulativeReceived;

  // Auto update transaction status (only depends on known final balance)
  useEffect(() => {
    if (totalWithPrevious > 0 && currentBalance <= 0) {
      setValue("transactionStatus", "Completed");
    } else {
      setValue("transactionStatus", "Pending");
    }
  }, [currentBalance, totalWithPrevious, setValue]);
  // Calculation End

  const orderProducts = useWatch({ name: "orderProducts", control });

  const watchedProducts = useWatch({ control, name: "orderProducts" });
  const discount = useWatch({ control, name: "discountPrice" }) || 0;
  const gstPercent = useWatch({ control, name: "gstPercentage" }) || 0;

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/orders`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add order",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        if (error.response?.status == 400) {
          const message =
            error.response?.data?.message ||
            "Bad Request: Please check your input and try again.";
          alert(message);
        } else {
          alert("Failed to add Orders. Please try again.");
        }
      },
    }
  );
  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/orders/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add order",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the Orders. Please try again.");
      },
    }
  );

  // REPEAT API START
  const { mutate: repeatMutate, isLoading: repeatLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/orders`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add order",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add Orders. Please try again.");
      },
    }
  );

  // SETVALUE FOR STATE VALUE

  console.log("state", state);

  useEffect(() => {
    if (state) {
      setValue("id", state?.id || 0);
      setValue("orderId", state?.orderId || "");
      setValue("customerName", state?.customerName || "");
      setValue("customerAddress", state?.customerAddress || "");
      setValue("contact", state?.contact || null);
      setValue("pincode", state?.pincode || "");
      setValue(
        "salesDate",
        state?.salesDate ? moment(state?.salesDate).format("YYYY-MM-DD") : null
      );

      setValue("gstNumber", state?.gstNumber || "");
      setValue("customerLevel", state?.customerLevel || "");
      setValue("lineroute", state?.lineroute || "");
      setValue("routeName", state?.routeName || "");
      setValue("state", state?.state || "");
      setValue("executiveName", state?.executiveName || "");
      setValue("transactionMode", state?.transactionMode || "");
      setValue("transactionStatus", state?.transactionStatus || "");
      setValue("deliveryStatus", state?.deliveryStatus || "");
      setValue("gstPercentage", state?.gstPercentage || "");
      setValue("discountPrice", state?.discountPrice || "");
      setValue("totalInvoiceAmount", state?.totalInvoiceAmount || "");
      setValue("selectFormat", state?.selectFormat || "");
      setValue("vehiclenumber", state?.vehiclenumber || "");
      setValue("invoiceNo", state?.invoiceNo || "");

      // setValue("orderProducts", state?.orderProducts || []);

      if (state?.orderProducts?.length > 0) {
        replace(
          state?.orderProducts?.map((item) => ({
            product: item?.product || null,
            quantity: item?.quantity || null,
            unitPrice: item?.unitPrice || null,
            discountPrice: item?.discountPrice || null,
            quantityType: item?.quantityType || null,
            price: item?.price || null,
            orderAdd: item?.orderAdd || null,
            salesDate: item?.salesDate || null,
            hsnCode: item?.hsnCode || null,
            mrpPrice: item?.mrpPrice || null,
            gstPercentage: item?.gstPercentage || null,
          }))
        );
      }
    }
  }, [state, setValue, replace]);

  // FORM SUBMIT
  const onSubmit = (data) => {
    const newReceived = cumulativeReceived + currentAmt;
    const newBalance = totalAmount - newReceived;
    const paymentStatus = newBalance <= 0 ? "Completed" : "Pending";

    const newPayment = {
      totalAmount,
      receivedAmount: currentAmt,
      balanceAmount: newBalance,
      paymentDate: new Date().toISOString().split("T")[0],
      status: paymentStatus,
    };

    // const updatedList = [...paymentList, newPayment];
    // setPaymentList(updatedList);

    let updatedList = [];
    if (paymentList?.length > 0) {
      // Replace last payment row
      updatedList = [...paymentList];
      updatedList[updatedList.length - 1] = newPayment;
    } else {
      // First time payment
      updatedList = [newPayment];
    }

    setPaymentList(updatedList);

    // Reset form fields
    reset({
      amtToPay: "",
      totalInvoiceAmount: totalWithPrevious,
      transactionStatus: paymentStatus,
    });

    const formData = {
      customerName: data?.customerName || "",
      customerAddress: data?.customerAddress || "",
      contact: data?.contact || null,
      pincode: data?.pincode || "",
      salesDate: data?.salesDate || null,
      gstNumber: data?.gstNumber || "",
      customerLevel: data?.customerLevel || "",
      lineroute: data?.lineroute || "",
      executiveName: data?.executiveName || "",
      transactionMode: data?.transactionMode || "",
      transactionStatus: paymentStatus,
      orderProducts: orderProducts.filter((p) => p.product),
      deliveryStatus: data?.deliveryStatus || "",
      gstPercentage: data?.gstPercentage || 0,
      discountPrice: data?.discountPrice || 0,
      // totalInvoiceAmount: data?.totalInvoiceAmount || 0,
      totalInvoiceAmount: data?.totalInvoiceAmount || 0,
      balanceAmount: isEditMode ? 0 : existingBalance || 0,
      hsnCode: data?.hsnCode || "",
      amtToPay: currentAmt,
      routeName: data?.routeName || "",
      state: data?.state || "",
      selectFormat: data?.selectFormat || "",
      vehiclenumber: data?.vehiclenumber || null,
      invoiceNo: data?.invoiceNo || state?.invoiceNo,
      // Keep existing payment list (do not add new row if completed)
      payments: updatedList,
    };

    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  // REPEAT ORDER

  const handleRepeatOrder = () => {
    if (!state) return;

    const newReceived = cumulativeReceived + currentAmt;
    const newBalance = totalAmount - newReceived;
    const paymentStatus = newBalance <= 0 ? "Completed" : "Pending";

    const newPayment = {
      totalAmount,
      receivedAmount: currentAmt,
      balanceAmount: newBalance,
      paymentDate: new Date().toISOString().split("T")[0],
      status: paymentStatus,
    };

    const updatedList = [...paymentList, newPayment];
    setPaymentList(updatedList);

    // Reset form fields
    reset({
      amtToPay: "",
      totalInvoiceAmount: totalWithPrevious,
      transactionStatus: paymentStatus,
    });

    const repeatFormData = {
      customerName: data?.customerName || "",
      customerAddress: data?.customerAddress || "",
      contact: data?.contact || null,
      pincode: data?.pincode || "",
      salesDate: data?.salesDate || null,
      gstNumber: data?.gstNumber || "",
      customerLevel: data?.customerLevel || "",
      lineroute: data?.lineroute || "",
      executiveName: data?.executiveName || "",
      transactionMode: data?.transactionMode || "",
      transactionStatus: paymentStatus,
      orderProducts: orderProducts.filter((p) => p.product),
      deliveryStatus: data?.deliveryStatus || "",
      gstPercentage: data?.gstPercentage || 0,
      discountPrice: data?.discountPrice || 0,
      // totalInvoiceAmount: data?.totalInvoiceAmount || 0,
      totalInvoiceAmount: data?.totalInvoiceAmount || 0,
      balanceAmount: existingBalance || 0,
      hsnCode: data?.hsnCode || "",
      amtToPay: currentAmt,
      routeName: data?.routeName || "",
      state: data?.state || "",
      selectFormat: data?.selectFormat || "",
      vehiclenumber: data?.vehiclenumber || null,
      // Keep existing payment list (do not add new row if completed)
      payments: updatedList,
    };

    repeatMutate(repeatFormData);
  };

  // GET API START FOR EXECUTIVE
  const {
    data: executiveDetails,
    isLoading: executiveLoading,
    refetch: executiveRefetch,
  } = useQuery("executive", executiveData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR EXECUTIVE

  const executives = executiveDetails?.data;

  const executiveNames = executives?.map((data) => {
    return `${data?.executiveName} : ${data?.phoneNumber}`;
  });

  // GET API START FOR CUSTOMERS
  const {
    data: customerDetails,
    isLoading: customerLoading,
    refetch: cutomerRefetch,
  } = useQuery("customer", customerData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR CUSTOMERS

  let customerLevel = customerDetails?.data;

  let customerRoute = customerDetails?.data;

  useEffect(() => {
    if (customerName && customerDetails?.data?.length > 0) {
      const matched =
        customerDetails &&
        customerDetails?.data?.filter((c) => c.customerName == customerName);

      if (matched?.length == 1) {
        // Only one match, auto-fill contact
        setValue("contact", matched[0].contact);
        setSelectedCustomer(matched[0]);
      } else if (matched?.length > 1 && contact) {
        // Multiple matches, use contact to disambiguate
        const exactMatch = matched?.find((c) => c.contact === contact);
        setSelectedCustomer(exactMatch || null);
      } else {
        setSelectedCustomer(null);
      }
    }
  }, [customerName, contact, customerDetails, setValue]);

  // SETVALUE FPR CUSTOMER DETAILS

  // ✅ Auto-fill customer fields when mobile number selection changes
  useEffect(() => {
    if (selectedCustomer) {
      setValue("customerName", selectedCustomer?.customerName || "");
      setValue("customerAddress", selectedCustomer?.customerAddress || "");
      setValue("pincode", selectedCustomer?.pincode || "");
      setValue("contact", selectedCustomer?.contact || "");
      setValue("gstNumber", selectedCustomer?.gstNumber || "");
      setValue("customerLevel", selectedCustomer?.customerLevel || "");
      setValue("lineroute", selectedCustomer?.lineRoute || "");
      setValue("routeName", selectedCustomer?.routeName || "");
      setValue("state", selectedCustomer?.state || "");
    }
  }, [selectedCustomer, setValue]);

  // GET API START FOR PRODUCT
  const {
    data: productDetails,
    isLoading: productLoading,
    refetch: productRefetch,
  } = useQuery("purchase", purchaseData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR PRODUCT

  let products = productDetails?.data || [];

  let productDataa =
    products && products?.flatMap((d) => d?.vendorDetails || []);

  const productOptions = productDataa?.map((product) => ({
    label: product?.product,
    value: product?.product,
  }));

  // // CALCULATION FOR FORM TOTAL
  const productsCalculation =
    watchedProducts?.filter(item => item.product)?.map((item) => {
      const quantity = Number(item?.quantity || 0);
      const unitPrice = Number(item?.unitPrice || 0);
      const gstPercent = Number(item?.gstPercentage || 0);

      const baseAmount = quantity * unitPrice;
      const gstAmount = (baseAmount * gstPercent) / 100;
      const totalAmount = baseAmount + gstAmount;

      return {
        baseAmount,
        gstAmount,
        totalAmount,
      };
    }) || [];

  const totalBeforeDiscount = productsCalculation?.reduce(
    (sum, p) => sum + p.totalAmount,
    0
  );

  const discountAmount = Number(discount || 0);

  // const existingBalance = Number(
  //   lastOrder?.payments?.at(-1)?.balanceAmount || 0
  // );

  // const totalInvoiceAmount =
  //   totalBeforeDiscount - discountAmount + existingBalance;

  // useEffect(() => {
  //   const rounded = Math.round(totalInvoiceAmount);
  //   setValue("totalInvoiceAmount", rounded);
  // }, [totalInvoiceAmount, setValue]);

  const isEditMode = Boolean(state?.id); // true if editing

  let totalInvoiceAmount = totalBeforeDiscount - discountAmount;

  if (!isEditMode && existingBalance > 0) {
    totalInvoiceAmount += existingBalance;
  }

  useEffect(() => {
    const rounded = Math.round(totalInvoiceAmount);
    setValue("totalInvoiceAmount", rounded);
  }, [totalInvoiceAmount, setValue]);

  // Preview payment values: show payment details when totals exist,
  // but do NOT assume any received amount unless user enters `amtToPay`.
  const previewReceived = currentAmt > 0 ? currentAmt : 0;
  const previewBalance = Number(totalAmount) - (Number(cumulativeReceived) + Number(previewReceived));

  return (
    <>
      <div className="form_main_block">
        <div className="form_sub_block">
          <form className="p-4" onSubmit={handleSubmit(onSubmit)}>
            {/* <div>
              <h6
                className="payment_title"
                style={{ borderBottom: "1px solid", display: "inline-block" }}
              >
                CUSTOMER DETAILS
              </h6>
            </div> */}
            {/* ✅ Top Section */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // Title left, input right
                flexWrap: "wrap", // Makes it responsive
                gap: "12px",
                marginBottom: "15px",
              }}
            >
              {/* 📝 Title */}
              <h6
                className="payment_title"
                style={{
                  borderBottom: "1px solid #000",
                  margin: 0,
                  fontSize: "14px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                CUSTOMER DETAILS
              </h6>

              {/* 📝 Show Select Customer only if NOT in edit mode */}
              {!state?.id && (
                <div
                  style={{
                    minWidth: "280px",
                    maxWidth: "350px",
                    flex: "1",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <label
                    htmlFor="customerSelect"
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      marginBottom: "2px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Select Customer <span style={{ color: "red" }}>*</span>
                  </label>

                  <input
                    id="customerSelect"
                    type="text"
                    list="mobileList"
                    placeholder="Select Customer (Name - Mobile)"
                    className="product_input_field"
                    required={!state?.id} // ✅ Required only if no state.id
                    style={{
                      width: "100%",
                      fontSize: "13px",
                      padding: "7px 8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                    onChange={(e) => {
                      const value = e.target.value.trim();

                      if (value === "") {
                        setSelectedCustomer(null);
                        setValue("customerName", "");
                        setValue("contact", "");
                        setValue("customerAddress", "");
                        setValue("pincode", "");
                        setValue("gstNumber", "");
                        setValue("customerLevel", "");
                        setValue("lineroute", "");
                        setValue("routeName", "");
                        setValue("state", "");
                        return;
                      }

                      const found = customerDetails?.data?.find(
                        (c) =>
                          `${c?.customerName} - ${c?.contact}` === value ||
                          String(c?.contact) === value
                      );

                      if (found) {
                        setSelectedCustomer(found);
                      } else {
                        setSelectedCustomer(null);
                        setValue("customerName", "");
                        setValue("contact", "");
                        setValue("customerAddress", "");
                        setValue("pincode", "");
                        setValue("gstNumber", "");
                        setValue("customerLevel", "");
                        setValue("lineroute", "");
                        setValue("routeName", "");
                        setValue("state", "");
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value.trim();

                      const found = customerDetails?.data?.find(
                        (c) =>
                          `${c?.customerName} - ${c?.contact}` === value ||
                          String(c?.contact) === value
                      );

                      if (!found) {
                        setSelectedCustomer(null);
                        setValue("customerName", "");
                        setValue("contact", "");
                        setValue("customerAddress", "");
                        setValue("pincode", "");
                        setValue("gstNumber", "");
                        setValue("customerLevel", "");
                        setValue("lineroute", "");
                        setValue("routeName", "");
                        setValue("state", "");
                      }
                    }}
                  />

                  <datalist id="mobileList">
                    {customerDetails?.data?.map((cust, i) => (
                      <option
                        key={i}
                        value={`${cust?.customerName} - ${cust?.contact}`}
                      />
                    ))}
                  </datalist>
                </div>
              )}
            </div>

            <div className="row px-3 d-flex gap-3 my-2">
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">
                  Customer Name
                  <span style={{ color: "red" }}>*</span>
                </label>

                {/* <Controller
                  name="customerName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Customer Name is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="Customer Name"
                        className="product_input_field"
                        list="customerList"
                      />
                      <datalist id="customerList">
                        {customerDetails?.data?.map((data, i) => (
                          <option key={i} value={data?.customerName}>
                            {`${data?.customerName}: ${data?.contact}`}
                          </option>
                        ))}
                      </datalist>

                      {error && (
                        <p className="text-danger small">{error?.message}</p>
                      )}
                    </>
                  )}
                /> */}
                <Controller
                  name="customerName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Customer Name"
                      className="product_input_field"
                      readOnly
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Contact Number</label>
                <Controller
                  name="contact"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="tel"
                      placeholder="8010389345"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Customer Address</label>
                <Controller
                  name="customerAddress"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Customer Address"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">State</label>
                <Controller
                  name="state"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Tamil Nadu"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Pincode</label>
                <Controller
                  name="pincode"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="number"
                      step="any"
                      placeholder="636123"
                      className="product_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Sales Date</label>
                <Controller
                  name="salesDate"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">GST Number</label>
                <Controller
                  name="gstNumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="8010389345"
                      className="product_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Customer Level</label>

                <Controller
                  name="customerLevel"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    const uniqueCustomerLevels = [
                      ...new Set(
                        customerLevel?.map((item) => item?.customerLevel)
                      ),
                    ];

                    return (
                      <select {...field} className="product_input_field">
                        <option value="">Select Customer Level</option>
                        {uniqueCustomerLevels?.map((level, index) => (
                          <option key={index} value={level}>
                            {level}
                          </option>
                        ))}
                      </select>
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Line Route</label>

                <Controller
                  name="lineroute"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    // Remove duplicate lineRoute values
                    const uniqueLineRoutes = [
                      ...new Set(customerRoute?.map((item) => item?.lineRoute)),
                    ];

                    return (
                      <select {...field} className="product_input_field">
                        <option value="">Select Line Route</option>
                        {uniqueLineRoutes?.map((route, index) => (
                          <option key={index} value={route}>
                            {route}
                          </option>
                        ))}
                      </select>
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Route Name</label>
                {/* <Controller
                  name="routeName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      className="product_input_field"
                      placeholder="Enter Route Name"
                    />
                  )}
                /> */}
                <Controller
                  name="routeName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    // Remove duplicate lineRoute values
                    const uniqueLineRoutes = [
                      ...new Set(customerRoute?.map((item) => item?.routeName)),
                    ];

                    return (
                      <select {...field} className="product_input_field">
                        <option value="">Select Route Name</option>
                        {uniqueLineRoutes?.map((route, index) => (
                          <option key={index} value={route}>
                            {route}
                          </option>
                        ))}
                      </select>
                    );
                  }}
                />
              </div>
              {state?.id ? (
                <>
                  <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                    <label
                      className="executive_label"
                      style={{ visibility: "hidden" }}
                    >
                      Line Route
                    </label>

                    <div className="repeat_order d-flex align-items-center">
                      <div className="download_image_block">
                        <img
                          src={Images?.repeatOrder}
                          className="image_icon"
                          alt="no-image"
                        />
                      </div>
                      <button
                        className="download_btn"
                        type="button"
                        onClick={handleRepeatOrder}
                      >
                        {repeatLoading ? (
                          <>
                            <i class="fa fa-spinner fa-spin"></i>
                          </>
                        ) : (
                          <> REPEAT ORDER</>
                        )}
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>

            {/* <div className="row px-3 d-flex gap-3 my-2">
       
            </div> */}


            <div className="product-details-container mb-4">
              <h6
                className="payment_title mb-3"
                style={{
                  borderBottom: "1px solid #dee2e6",
                  display: "inline-block",
                  paddingBottom: '4px'
                }}
              >
                PRODUCT DETAILS
              </h6>

              {/* Desktop Header Row */}
              <div className="row g-2 align-items-center mb-2 fw-bold d-none d-md-flex text-dark">
                <div className="col-md-3">Product *</div>
                <div className="col-md-1">HSN</div>
                <div className="col-md-1">Qty *</div>
                <div className="col-md-2">Type</div>
                <div className="col-md-1">Unit Price</div>
                <div className="col-md-1">GST %</div>
                <div className="col-md-1">Price</div>
                <div className="col-md-1">MRP</div>
                <div className="col-md-1 text-center">Action</div>
              </div>

              {/* Product Rows */}
              {fields?.map((field, index) => {
                const productValue = watch(`orderProducts.${index}.product`);
                const quantity = parseFloat(orderProducts?.[index]?.quantity || 0);
                const unitPrice = parseFloat(orderProducts?.[index]?.unitPrice || 0);
                const gstPercentage = parseFloat(orderProducts?.[index]?.gstPercentage || 0);

                const subtotal = unitPrice * quantity;
                const gstAmount = (subtotal * gstPercentage) / 100;
                const total = subtotal + gstAmount;

                return (
                  <div className="row g-2 align-items-start mb-3 mb-md-2 pb-3 pb-md-2 border-bottom border-light-subtle" key={field?.id}>

                    {/* 1. Product Select (col-md-3) */}
                    <div className="col-12 col-md-3">
                      <label className="d-md-none form-label text-secondary mb-1">Product *</label>
                      <Controller
                        name={`orderProducts.${index}.product`}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <div>
                            <Select
                              {...field}
                              options={productOptions}
                              placeholder="Select Product"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base, state) => ({
                                  ...base,
                                  minHeight: '38px',
                                  height: '38px',
                                  borderRadius: '0.375rem',
                                  borderColor: state.isFocused ? '#86b7fe' : '#212529',
                                  boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : null,
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  padding: '0 8px',
                                  height: '38px',
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: '38px',
                                }),
                              }}
                              onChange={(selectedOption) => {
                                const selectedValue = selectedOption?.value || "";
                                field.onChange(selectedValue);
                                const selectedProduct = productDataa?.find((p) => p?.product === selectedValue);

                                if (selectedProduct) {
                                  const levelPriceMap = {
                                    "High Level": selectedProduct?.highLevelCustomer,
                                    "Mid Level": selectedProduct?.midLevelCustomer,
                                    "Low Level": selectedProduct?.lowLevelCustomer,
                                  };
                                  const updatedPrice = Number(levelPriceMap[customersLevels]);
                                  const gstPercentage = Number(selectedProduct?.gstPercentage);
                                  const actualAmount = !isNaN(updatedPrice) && updatedPrice > 0
                                    ? +(updatedPrice / (1 + gstPercentage / 100)).toFixed(2)
                                    : "";

                                  if (actualAmount !== "") {
                                    setValue(`orderProducts.${index}.unitPrice`, actualAmount);
                                  } else {
                                    setValue(`orderProducts.${index}.unitPrice`, "");
                                  }
                                  setValue(`orderProducts.${index}.gstPercentage`, gstPercentage || "");
                                  setValue(`orderProducts.${index}.quantityType`, selectedProduct?.quantityType || "");
                                  setValue(`orderProducts.${index}.hsnCode`, selectedProduct?.hsncode || "");
                                } else {
                                  setValue(`orderProducts.${index}.unitPrice`, "");
                                  setValue(`orderProducts.${index}.gstPercentage`, "");
                                  setValue(`orderProducts.${index}.quantityType`, "");
                                  setValue(`orderProducts.${index}.hsnCode`, "");
                                }

                                // Automatically append a new row if this is the last row and a product is selected
                                if (selectedValue && index === fields.length - 1) {
                                  append({
                                    product: "",
                                    quantity: "",
                                    quantityType: "",
                                    unitPrice: "",
                                    price: "",
                                    gstPercentage: "",
                                    mrpPrice: "",
                                    hsnCode: "",
                                    salesDate: moment().format("YYYY-MM-DD"),
                                  });
                                }
                              }}
                              value={productOptions?.find((option) => option?.value === field?.value)}
                              isClearable
                            />
                            {error && <div className="text-danger small mt-1" style={{ fontSize: '0.75rem' }}>{error?.message}</div>}
                          </div>
                        )}
                      />
                    </div>

                    {/* 2. HSN (col-md-1) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1">HSN</label>
                      <Controller
                        name={`orderProducts.${index}.hsnCode`}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control border-dark"
                            placeholder="HSN"
                            readOnly
                          />
                        )}
                      />
                    </div>

                    {/* 3. Quantity (col-md-1) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1">Qty *</label>
                      <Controller
                        name={`orderProducts.${index}.quantity`}
                        control={control}
                        defaultValue=""
                        render={({ field, fieldState: { error } }) => (
                          <>
                            <input
                              {...field}
                              type="number"
                              step="any"
                              className={`form-control border-dark ${error ? "is-invalid" : ""
                                }`}
                              placeholder="Qty"
                            />
                            {error && <div className="invalid-feedback" style={{ fontSize: '0.75rem' }}>{error.message}</div>}
                          </>
                        )}
                      />
                    </div>

                    {/* 4. Type (col-md-2) */}
                    <div className="col-6 col-md-2">
                      <label className="d-md-none form-label text-secondary mb-1">Type</label>
                      <Controller
                        name={`orderProducts.${index}.quantityType`}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <select {...field} className="form-select border-dark">
                            <option value="">Type</option>
                            <option value="PCS">PCS</option>
                            <option value="KG">KG</option>
                            <option value="LTR">LTR</option>
                            <option value="G">G</option>
                            <option value="BOX">BOX</option>
                            <option value="BOXES">BOXES</option>
                            <option value="Other">Other</option>
                          </select>
                        )}
                      />
                    </div>

                    {/* 5. Unit Price (col-md-1) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1">Unit Price</label>
                      <Controller
                        name={`orderProducts.${index}.unitPrice`}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            step="any"
                            className="form-control border-dark"
                            placeholder="Price"
                            readOnly={customersLevels !== "Others"}
                          />
                        )}
                      />
                    </div>

                    {/* 6. GST (col-md-1) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1">GST %</label>
                      <Controller
                        name={`orderProducts.${index}.gstPercentage`}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            step="any"
                            className="form-control border-dark"
                            placeholder="GST"
                          />
                        )}
                      />
                    </div>

                    {/* 7. Price (col-md-1) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1">Price</label>
                      <Controller
                        name={`orderProducts.${index}.price`}
                        control={control}
                        defaultValue={0}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            className="form-control border-dark"
                            placeholder="Total"
                            readOnly={customersLevels !== "Others"}
                            value={customersLevels !== "Others" ? (total > 0 ? total.toFixed(2) : 0) : field.value}
                            onChange={(e) => {
                              const val = e.target.value;
                              field.onChange(val);
                              if (customersLevels === "Others") {
                                const gstPercent = Number(getValues(`orderProducts.${index}.gstPercentage`) || 0);
                                const inclusivePrice = Number(val);
                                if (!isNaN(inclusivePrice) && inclusivePrice > 0) {
                                  const actualPrice = +(inclusivePrice / (1 + gstPercent / 100)).toFixed(2);
                                  setValue(`orderProducts.${index}.unitPrice`, actualPrice);
                                } else {
                                  setValue(`orderProducts.${index}.unitPrice`, "");
                                }
                              }
                            }}
                          />
                        )}
                      />
                    </div>

                    {/* 8. MRP (col-md-1) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1">MRP</label>
                      <Controller
                        name={`orderProducts.${index}.mrpPrice`}
                        control={control}
                        defaultValue={0}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            step="any"
                            className="form-control border-dark"
                            placeholder="MRP"
                          />
                        )}
                      />
                    </div>

                    {/* 9. Action (col-6 on mobile, col-md-1 on desktop) */}
                    <div className="col-6 col-md-1">
                      <label className="d-md-none form-label text-secondary mb-1 invisible">Action</label>
                      <div className="d-flex align-items-center justify-content-center" style={{ height: '38px' }}>
                        {index === fields.length - 1 && (
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: '38px', height: '38px', cursor: 'pointer' }}
                            title="Add New Product"
                            onClick={() => {
                              append({
                                product: "",
                                quantity: "",
                                quantityType: "",
                                otherQuantityType: "",
                                unitPrice: "",
                                discountPrice: "",
                                price: "",
                                orderAdd: "",
                                gstPercentage: "",
                                mrpPrice: "",
                                hsnCode: "",
                                salesDate: moment().format("YYYY-MM-DD"),
                              });
                            }}
                          >
                            <img src={Images?.orderAdd} alt="Add" style={{ width: '30px', height: '30px' }} />
                          </div>
                        )}

                        {index > 0 && (
                          <div
                            className="d-flex align-items-center justify-content-center border border-danger rounded-circle p-1"
                            style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                            title="Remove Product"
                            onClick={() => remove(index)}
                          >
                            <span className="text-danger fw-bold" style={{ fontSize: '1.2rem', lineHeight: 1 }}>&times;</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="row px-3 d-flex gap-3 my-2">
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">GST %(Over All) </label>
                <Controller
                  name="gstPercentage"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <input
                        {...field}
                        type="number"
                        step="any"
                        placeholder="GST"
                        className="product_input_field border-dark"
                      />
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">
                  Discount Amount (&#8377;)
                </label>
                <Controller
                  name="discountPrice"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <input
                        {...field}
                        type="number"
                        step="any"
                        placeholder="Discount"
                        className="product_input_field border-dark"
                      />
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Total Amount </label>
                <Controller
                  name="totalInvoiceAmount"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <input
                        {...field}
                        type="number"
                        step="any"
                        placeholder="0.00"
                        className="product_input_field border-dark"
                        readOnly
                      />
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Amount To Pay </label>
                <Controller
                  name="amtToPay"
                  control={control}
                  defaultValue=""
                  rules={{
                    validate: (value) => {
                      const total = Number(totalAmount);

                      const amountToPay = Number(value) || 0;
                      if (amountToPay > total) {
                        return "Amount to pay cannot exceed total invoice amount";
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        type="number"
                        step="any"
                        placeholder="Pay Amount"
                        className="product_input_field border-dark"
                      />
                      {error && (
                        <p className="text-danger small">{error?.message}</p>
                      )}
                    </>
                  )}
                />
              </div>
            </div>

            <hr />
            <h6
              className="payment_title"
              style={{ borderBottom: "1px solid", display: "inline-block" }}
            >
              Payment Details
            </h6>
            <hr />
            {lastOrder && !state?.id && (
              <>
                <h6
                  className="payment_title"
                  style={{
                    borderBottom: "1px solid",
                    display: "inline-block",
                  }}
                >
                  Previous Details
                </h6>
                <div className="table-responsive">
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th className="payment_table_heading">Total Amout</th>
                        <th className="payment_table_heading">
                          Received Amount
                        </th>
                        <th className="payment_table_heading">
                          Balance Amount
                        </th>
                        <th className="payment_table_heading">Payment Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lastOrder &&
                        lastOrder?.payments?.map((entry, index) => (
                          <tr key={index}>
                            <td className="payment_table_data">
                              {Number(entry?.totalAmount || 0).toFixed(2)}
                            </td>
                            <td className="payment_table_data">
                              {Number(entry?.receivedAmount || 0).toFixed(2)}
                            </td>
                            <td className="payment_table_data">
                              {Number(entry?.balanceAmount || 0).toFixed(2)}
                            </td>
                            <td className="payment_table_data">
                              {entry?.paymentDate
                                ? moment(entry?.paymentDate).format(
                                  "DD-MM-YYYY"
                                )
                                : "-"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <hr />
              </>
            )}
            <h6
              className="payment_title"
              style={{ borderBottom: "1px solid", display: "inline-block" }}
            >
              Current Payment{" "}
            </h6>
            <div className="table-responsive">
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th className="payment_table_heading">Total Amout</th>
                    <th className="payment_table_heading">Received Amount</th>
                    <th className="payment_table_heading">Balance Amount</th>
                    <th className="payment_table_heading">Payment Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentList?.map((entry, index) => (
                    <tr key={index}>
                      <td className="payment_table_data">
                        {Number(entry?.totalAmount || 0).toFixed(2)}
                      </td>
                      <td className="payment_table_data">
                        {Number(entry?.receivedAmount || 0).toFixed(2)}
                      </td>
                      <td className="payment_table_data">
                        {Number(entry?.balanceAmount || 0).toFixed(2)}
                      </td>
                      <td className="payment_table_data">
                        {entry?.paymentDate
                          ? moment(entry?.paymentDate).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                    </tr>
                  ))}
                  {totalAmount > 0 && (
                    <tr className="table-info">
                      <td className="payment_table_data">
                        {Number(totalAmount || 0).toFixed(2)}
                      </td>
                      <td className="payment_table_data">
                        {previewReceived > 0 ? Number(previewReceived).toFixed(2) : ""}
                      </td>
                      <td className="payment_table_data">
                        {Number(previewBalance || 0).toFixed(2)}
                      </td>
                      <td className="payment_table_data">
                        {moment().format("DD-MM-YYYY")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <hr />

            <div className="row px-3 d-flex gap-3 my-2">
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">
                  Executive Name<span style={{ color: "red" }}>*</span>{" "}
                </label>
                <Controller
                  name="executiveName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Executive name is required" }} // <-- Required rule added
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        list="executive-list"
                        className="product_input_field"
                        placeholder="Select executive"
                        onChange={(e) => {
                          const selectedName = e.target.value;
                          field.onChange(selectedName); // update form value

                          // Find the executive in your data
                          const selectedExecutive = executives?.find(
                            (data) => data?.executiveName === selectedName
                          );

                          // If found, set the vehicle number
                          if (selectedExecutive) {
                            setValue(
                              "vehiclenumber",
                              selectedExecutive?.vehicleNumber || ""
                            );
                          }
                        }}
                      />
                      <datalist id="executive-list">
                        {executives?.map((data, index) => (
                          <option key={index} value={data?.executiveName}>
                            {`${data?.executiveName} : ${data?.phoneNumber}`}
                          </option>
                        ))}
                      </datalist>
                      {error && (
                        <p
                          className="text-danger"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {error.message}
                        </p>
                      )}
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Vehicle Number</label>
                <Controller
                  name="vehiclenumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="TN003"
                        className="product_input_field"
                      />
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Transaction Mode </label>
                <Controller
                  name="transactionMode"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="">None</option>
                      <option value="Cash">Cash</option>
                      <option value="Online">Online</option>
                      <option value="Credit">Credit</option>
                    </select>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Transaction Status </label>
                <Controller
                  name="transactionStatus"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="">None</option>
                      <option value="Pending">Pending</option>
                      <option value="Completed">Completed</option>
                    </select>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Delivery Status </label>
                <Controller
                  name="deliveryStatus"
                  control={control}
                  defaultValue="Processing"
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="">None</option>
                      <option value="Processing">Processing</option>
                      <option value="Canceled">Canceled</option>
                      <option value="Return">Return</option>
                      <option value="Delivered">Delivered</option>
                    </select>
                  )}
                />
              </div>
            </div>
            <div className="row px-3 my-4">
              <div className="col-12 col-md-2 p-0">
                <button className="product_form_submit_btn" type="submit">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PopupModel
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Orders Added Successfully!"
        updatemessage="Orders Updated Successfully!"
        state={state?.id}
        navigateUrl="/viewOrder"
      />
    </>
  );
};

export default NewOrder;
